module.exports = __webpack_public_path__ + "static/media/parallax-form-9.18b38aff.svg";